// The band the server last put this browser in.
//
// The landing draws before anything is known for certain: the typed birth
// year is the weakest signal there is, and it can say "adult" about someone
// the age check -- or an administrator's override -- has placed with the
// minors. The server's last word arrives in WELCOME and is remembered here, so
// the next landing can hide what a minor is never offered ("camera opens from
// the start") instead of showing it and having the app quietly ignore it.
// Convenience for the screen; the server decides regardless. No imports, so a
// test can load it without a browser. ASCII only.
const BAND_KEY = 'lumi.band';

/** @returns {'minor'|'adult'|null} */
export function getRememberedBand() {
  try {
    const b = localStorage.getItem(BAND_KEY);
    return b === 'minor' || b === 'adult' ? b : null;
  } catch {
    return null;
  }
}

/** @param {string} band  from WELCOME */
export function rememberBand(band) {
  try {
    if (band === 'minor' || band === 'adult') localStorage.setItem(BAND_KEY, band);
  } catch {
    /* storage is a convenience */
  }
}

/**
 * Whether the landing should treat this person as a minor: the typed year
 * says so, OR the age check's verdict does, OR the server's last word does.
 * Any one of them is enough -- a minor is never offered a minor-unsafe option
 * because a different field happened to say adult.
 * @param {{ age: number|null, storedBand?: string|null, rememberedBand?: string|null }} x
 */
export function landingMinor({ age, storedBand = null, rememberedBand = null }) {
  return (age !== null && age < 18) || storedBand === 'minor' || rememberedBand === 'minor';
}
